module.exports = __webpack_public_path__ + "img/bootSpeedioNormal.27572d6f.svg";